export default "__VITE_ASSET__zrohZ95T__"